import * as React from 'react';

const GoogleLogo24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#4285F4",
    d: "M21.794 12.189c0-.71-.05-1.355-.17-2.015h-9.425v3.872h5.383a4.605 4.605 0 0 1-2.001 3.021v2.512h3.232c1.89-1.741 2.981-4.302 2.981-7.354v-.036Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#34A853",
    d: "M12.2 22c2.7 0 4.962-.9 6.622-2.421l-3.231-2.511c-.9.6-2.041.95-3.392.95-2.601 0-4.812-1.76-5.603-4.122H3.255v2.591A10.008 10.008 0 0 0 12.199 22Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#FBBC04",
    d: "M6.596 13.896a6.006 6.006 0 0 1 0-3.802V7.503H3.255a9.97 9.97 0 0 0-1.06 4.492c0 1.61.39 3.142 1.06 4.492l3.341-2.591Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#E94235",
    d: "M12.2 5.972c1.47 0 2.79.5 3.821 1.5l2.871-2.87C17.162 2.99 14.89 2 12.2 2c-3.912-.01-7.294 2.231-8.944 5.503l3.341 2.591c.79-2.361 2.992-4.122 5.603-4.122Z"
  }
));
GoogleLogo24.Size = 24;
GoogleLogo24.Title = "GoogleLogo";

export { GoogleLogo24 as default };
